export default "__VITE_ASSET__6792f794__"